import PropTypes from 'prop-types';
import { useState } from 'react';

import useImmersiveMenu from 'hb-react/shared/hooks/useImmersiveMenu';

import TopicCard from './TopicCard';
import TopicCardProvider from '../contexts/TopicCardContext';

export const getTopicImmersiveMenuHref = (
  whiteLabelURL,
  landingPage,
  topicId,
) => {
  const topicPath = `/topics/${topicId}`;

  return `${whiteLabelURL}${landingPage.replace(topicPath, '')}`;
};

const TopicItem = ({
  areActionsDisabled = false,
  canRemoveDescriptionPlaceholder,
  currentNetwork,
  topic,
  updateTopicApproval,
}) => {
  const [displayRequestModal, setDisplayRequestModal] = useState(false);

  const {
    id,
    landing_page: landingPage,
    white_label_url: whiteLabelURL,
  } = topic;

  const isImmersiveMenu = useImmersiveMenu({
    location: { pathname: landingPage },
    network: currentNetwork,
  });

  const getHref = () => {
    if (whiteLabelURL) {
      if (landingPage) {
        return isImmersiveMenu
          ? getTopicImmersiveMenuHref(whiteLabelURL, landingPage, id)
          : landingPage;
      }

      return whiteLabelURL;
    }

    return isImmersiveMenu
      ? `${window.location.origin}${landingPage}`
      : landingPage;
  };

  const href = getHref();

  const forceDefaultLink = !!(whiteLabelURL || isImmersiveMenu);

  return (
    <TopicCardProvider
      canRemoveDescriptionPlaceholder={canRemoveDescriptionPlaceholder}
      displayRequestModal={displayRequestModal}
      areActionsDisabled={areActionsDisabled}
      href={href}
      forceDefaultLink={forceDefaultLink}
      setDisplayRequestModal={setDisplayRequestModal}
      updateTopicApproval={updateTopicApproval}
      target={forceDefaultLink ? '_blank' : undefined}
      topic={topic}
    >
      <TopicCard />
    </TopicCardProvider>
  );
};

TopicItem.protoTypes = {
  canRemoveDescriptionPlaceholder: PropTypes.bool.isRequired,
  topic: PropTypes.object.isRequired,
};

export default TopicItem;
